module.exports = __webpack_public_path__ + "assets/jqtouch.3c1f6f6b.svg";